import React from "react";
import { siteContent, socialLinks } from "../content/site";
import "./Footer.css";

const Footer: React.FC = () => {
  const linkedInLink = socialLinks.find((link) => link.platform === "LinkedIn");
  const gitHubLink = socialLinks.find((link) => link.platform === "GitHub");

  return (
    <footer className="site-footer">
      <div className="section-shell site-footer__shell">
        <div className="site-footer__content">
          <a
            href="#hero"
            className="site-footer__brand"
          >
            {siteContent.person.brandName}
          </a>

          <div className="site-footer__links">
            {gitHubLink ? (
              <a
                href={gitHubLink.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer__link"
              >
                GitHub
              </a>
            ) : null}
            {linkedInLink ? (
              <a
                href={linkedInLink.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer__link"
              >
                LinkedIn
              </a>
            ) : null}
            <a
              href={`mailto:${siteContent.person.email}`}
              className="site-footer__link"
            >
              Email
            </a>
            <a href="#hero" className="site-footer__link">
              Back to top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
